import {Account, Cred, Resource} from '.';
import {LooseObject} from '../types';

export interface CreateReccoResourcePayload {
  source: 'EXTERNAL';
  url: string;
}

export enum Access {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export interface CreateReccoPayload {
  access?: Access;
  entityId: string;
  entityType: ENTITY_TYPE;
  keywords: string[];
  metadata?: LooseObject;
  reccoRequestId?: string;
  resourceIds: LooseObject[];
  text: string;
  wordCloud: string[];
}

export interface GiveReccoPayload {
  message: string;
  resources: string[];
}

export enum ENTITY_TYPE {
  BUSINESS = 'BUSINESS',
  EXPERIENCE = 'EXPERIENCE',
  PERSON = 'PERSON',
  PLACE = 'PLACE',
  PRODUCT = 'PRODUCT',
}

export class Recco {
  createdAt?: Date;
  createdBy: Account;
  cred: Cred;
  credOwner: Account;
  id: string;
  hashtags: string[];
  message: string;
  resources: Resource[];
  updatedAt?: Date;

  constructor(json: any) {
    this.createdAt = json.createdAt && new Date(json.createdAt);
    this.createdBy = json.createdBy && new Account(json.createdBy);
    this.cred = json.cred && new Cred(json.cred);
    this.credOwner = json.credOwner && new Account(json.credOwner);
    this.hashtags = json.hashtags;
    this.id = json.id || json._id;
    this.resources = json.resources?.map((resource: any) => new Resource(resource));
    this.message = json.message;
    this.updatedAt = json.updatedAt && new Date(json.updatedAt);
  }
}
